import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) {
    this.title.setTitle("Global Money Transfer | SingX");
    this.canonicalService.updateCanonicalUrl('/wallet');
    this.meta.updateTag({ name: 'description', content: 'Transfer Money Globally by using your Wallet balance with one click of a button and multiple overseas transfers. Global Mobile Top-ups and Bill Payments with One Click with SingX Only.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment, Money Transfer Overseas for Business.' })
    // this.meta.addTags([
    //   { name: 'description', content: 'Transfer Money Globally by using your Wallet balance with one click of a button and multiple overseas transfers. Global Mobile Top-ups and Bill Payments with One Click with SingX Only.' },
    //   { name: 'author', content: 'SingX' },
    //   { name: 'keywords', content: 'Instant Money Transfer Overseas, Money Transfer Overseas, International Money Transfer, remittance, Fast Money Transfer Overseas, Cheapest Way to Transfer Money Overseas, Online Money Transfer overseas, Best Money Transfer to India, International Business Payment, Money Transfer Overseas for Business.' }
    // ]);
  }

  ngOnInit(): void {
  }

}
